import classes from './ReportResult.module.css';
import { CustomTooltipWhite } from 'shared_ui_components';
import RoleplayRating from 'features/roleplay/Components/Common/RoleplayRating/RoleplayRating';
import { imageBasePath } from 'constants';
import { Skeleton } from '@material-ui/lab';

const Ratings = ({
  title = 'Ratings & Why You Got Them',
  rating_criteria = [],
  onlyRead = false,
  status_ai = '',
  isLoadingResponse = false,
  stillInProgress = false,
  globalRatingCriteria = [],
}) => {
  const getBorderColor = (number_of_stars) => {
    if (number_of_stars >= 0 && number_of_stars <= 2) return '#F0CBCB';
    if (number_of_stars === 4 || number_of_stars === 5) return 'rgba(150, 225, 198, 1)';
    return '#E1DF96';
  };

  function getRandomFeedback() {
    const messages = [
      'You nailed it. Keep the momentum going. 🚀',
      'Strong execution. Repeat this next time ✅',
      'Great energy and focus. Keep it up 🔥',
      'Fantastic delivery. Do more of this 🎯',
      'You’re a star. This is a top-tier work. 🌟',
    ];

    const randomIndex = Math.floor(Math.random() * messages.length);
    return messages[randomIndex];
  }

  if (stillInProgress)
    return (
      <div>
        <div className={classes.ratingTitle}>
          <h4>📚 {title}</h4>
          <CustomTooltipWhite
            tooltipIcon="info_icon.svg"
            title={
              <div>
                <p>
                  <strong>5 - Expert: </strong>
                  Develops new ways of applying this competence measured on the world stage.
                </p>
                <p>
                  <strong>4 - Proficient: </strong>
                  Encourages or supervises others in this competency.
                </p>
                <p>
                  <strong>3 - Competent: </strong>
                  Demonstrates this competency independent of supervision or encouragement.
                </p>
                <p>
                  <strong>2 - Advanced Beginner: </strong>
                  Demonstrates this competency under supervision or with encouragement.
                </p>
                <p>
                  <strong>1 - Novice: </strong>
                  Understands the competency and its importance.
                </p>
              </div>
            }
          >
            <img width={12} src={imageBasePath + 'info_icon.svg'} alt="" />
          </CustomTooltipWhite>
        </div>
        <div style={{ display: 'flex', gap: '0.5rem', flexDirection: 'column' }}>
          {globalRatingCriteria?.map((c) => (
            <div key={c?.uuid}>
              <div className={classes.criteriaContainer}>
                <b className="heading6">{c?.name}</b>
                <RoleplayRating withTooltip stars={0} />
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  return (
    <div>
      <div className={classes.ratingTitle}>
        <h4>📚 {title}</h4>
        <CustomTooltipWhite
          tooltipIcon="info_icon.svg"
          title={
            <div>
              <p>
                <strong>5 - Expert: </strong>
                Develops new ways of applying this competence measured on the world stage.
              </p>
              <p>
                <strong>4 - Proficient: </strong>
                Encourages or supervises others in this competency.
              </p>
              <p>
                <strong>3 - Competent: </strong>
                Demonstrates this competency independent of supervision or encouragement.
              </p>
              <p>
                <strong>2 - Advanced Beginner: </strong>
                Demonstrates this competency under supervision or with encouragement.
              </p>
              <p>
                <strong>1 - Novice: </strong>
                Understands the competency and its importance.
              </p>
            </div>
          }
        >
          <img width={12} src={imageBasePath + 'info_icon.svg'} alt="" />
        </CustomTooltipWhite>
      </div>
      {onlyRead ? (
        rating_criteria?.map((c) => (
          <div
            className={classes.ratingContainer}
            key={c?.rating_criteria?.uuid}
            style={{ border: `1px solid ${getBorderColor(c?.stars)}` }}
          >
            <div className={classes.criteriaContainer}>
              <b className="heading6">{c?.rating_criteria?.name}</b>

              <RoleplayRating withTooltip stars={c?.stars} />
            </div>
            <div>
              <div>
                <p className="heading7Bold" style={{ marginTop: '0.25rem' }}>
                  {c?.reasoning
                    ? 'Why I got this rating?'
                    : 'AI "Why I got this rating?" is not available'}
                </p>
                {c?.reasoning && (
                  <p className="heading7" style={{ marginTop: '0.25rem' }}>
                    {c?.reasoning}
                  </p>
                )}
              </div>

              {c?.star === 5 ? (
                <p className="heading7Bold" style={{ marginTop: '0.25rem' }}>
                  {getRandomFeedback()}
                </p>
              ) : (
                <div>
                  <p className="heading7Bold" style={{ marginTop: '0.25rem' }}>
                    {c?.improvement_suggestion
                      ? 'How to improve?'
                      : 'AI "How to improve?" is not available'}
                  </p>
                  {c?.improvement_suggestion && (
                    <p className="heading7" style={{ marginTop: '0.25rem' }}>
                      {c?.improvement_suggestion}
                    </p>
                  )}
                </div>
              )}
            </div>
          </div>
        ))
      ) : isLoadingResponse ? (
        <div className={classes.ratingContainer} style={{ border: `1px solid grey` }}>
          <Skeleton />
        </div>
      ) : (
        rating_criteria?.map((c) => (
          <div
            className={classes.ratingContainer}
            key={c?.uuid}
            style={{ border: `1px solid ${getBorderColor(c?.rating)}` }}
          >
            <div className={classes.criteriaContainer}>
              <b className="heading6">{c?.name}</b>
              <RoleplayRating withTooltip stars={status_ai === 'SUCCEEDED' ? c?.rating : 0} />
            </div>
            {status_ai === 'IN_PROGRESS' ? (
              <div>AI Rating in Progress…</div>
            ) : (
              <div>
                <div>
                  <p className="heading7Bold" style={{ marginTop: '0.25rem' }}>
                    {c?.reasoning
                      ? 'Why I got this rating?'
                      : 'AI "Why I got this rating?" is not available'}
                  </p>
                  {c?.reasoning && (
                    <p className="heading7" style={{ marginTop: '0.25rem' }}>
                      {c?.reasoning}
                    </p>
                  )}
                </div>

                {c?.star === 5 ? (
                  <p className="heading7Bold" style={{ marginTop: '0.25rem' }}>
                    {getRandomFeedback()}
                  </p>
                ) : (
                  <div>
                    <p className="heading7Bold" style={{ marginTop: '0.25rem' }}>
                      {c?.improvement_suggestion
                        ? 'How to improve?'
                        : 'AI "How to improve?" is not available'}
                    </p>
                    {c?.improvement_suggestion && (
                      <p className="heading7" style={{ marginTop: '0.25rem' }}>
                        {c?.improvement_suggestion}
                      </p>
                    )}
                  </div>
                )}
              </div>
            )}
          </div>
        ))
      )}
    </div>
  );
};

export default Ratings;
